module.exports = __webpack_public_path__ + "img/icon4.6cd8b76d.png";